// src/pages/About.jsx
import "./About.css";
import { FaWhatsapp, FaInstagram, FaFacebook, FaAt } from "react-icons/fa";

export default function About() {
  const galleryImages = [
    "/images/tour1.jpg",
    "/images/tour2.jpg",
    "/images/tour4.jpg",
    "/images/tou5.jpg",
    "/images/tour6.jpg",
    "/images/tour7.jpg",
    "/images/tour8.jpg",
    "/images/tour9.jpg",
    "/images/tour10.jpg"
  ];

  return (
    <section className="about">
      <div className="about-container">
        <div className="about-image">
          <img src="/images/muhammed.jpg" alt="Muhammed Salum" />
        </div>
        <div className="about-text">
          <h2>About Muhammed Salum</h2>
          <p>
            Muhammed Salum, the visionary founder of <strong>Muhammed Tours & Safaris</strong>, has dedicated his life to providing unforgettable travel experiences across Zanzibar, Tanzania, and East Africa. From an early age, Muhammed developed a deep appreciation for his homeland's rich culture, diverse wildlife, and stunning landscapes. His passion for connecting people to authentic experiences inspired him to start his own tour company, where every journey is crafted with care, knowledge, and a personal touch.  
          </p>
          <p>
            Over the years, Muhammed has become renowned for his professionalism, cultural expertise, and warm hospitality. Travelers from around the world rely on his guidance to explore Zanzibar’s hidden gems—from pristine beaches and coral reefs to historical Stone Town and traditional villages. Beyond tourism, Muhammed is deeply committed to sustainable practices and empowering local communities, supporting initiatives that preserve wildlife, protect the environment, and uplift local women and youth through tourism-related projects.  
          </p>
          <p>
            His tours are more than sightseeing trips; they are immersive cultural journeys. Muhammed personally ensures that every visitor experiences the vibrant Swahili culture, the island’s history, and the natural wonders that make Zanzibar unique. His philosophy is simple: travel should be meaningful, educational, and joyful. Whether it’s a family vacation, honeymoon, or adventure-seeker’s expedition, Muhammed’s hands-on approach and attention to detail ensure that every guest leaves with memories that last a lifetime.  
          </p>
          <p>
            With a career spanning over a decade in the travel and hospitality industry, Muhammed continues to innovate, expand, and elevate the experience of visiting Zanzibar. His dedication, authenticity, and passion have made him a trusted name among travelers seeking genuine, unforgettable experiences.
          </p>

          <h3>Tour Gallery</h3>
          <div className="gallery">
            {galleryImages.map((img, idx) => (
              <div className="gallery-item" key={idx}>
                <img src={img} alt={`Tour ${idx + 1}`} />
              </div>
            ))}
          </div>

          <h3>Get in Touch</h3>
          <ul className="contact-list">
            <li>
              📧 Email: 
              <a href="mailto:muhammedsalum625@gmail.com"> muhammedsalum625@gmail.com</a>
            </li>
            <li>
              📞 Phone: 
              <a href="tel:+255718665620"> +255 718 665 620</a>
            </li>
            <li>
              🌐 Social Media via direct link — click icons:
              <a
                href="https://wa.me/255718665620"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaWhatsapp size={24} color="#25D366" title="WhatsApp" />
              </a>
              <a
                href="https://facebook.com/muhammed.zanzibar.2025"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaFacebook size={24} color="#1877F2" title="Facebook" />
              </a>
              <a
                href="https://instagram.com/muhammed_zanzibar/"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaInstagram size={24} color="#C13584" title="Instagram" />
              </a>
              <a
                href="https://www.threads.net/@muhammed_zanzibar"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaAt size={24} color="#000000" title="Threads" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <style jsx>{`
        .about-container {
          display: flex;
          flex-wrap: wrap;
          gap: 2rem;
          max-width: 1200px;
          margin: 0 auto;
          padding: 2rem;
          align-items: flex-start;
        }

        /* Founder Image */
        .about-image img {
          width: 100%;
          max-width: 400px;
          height: 450px;
          border-radius: 12px;
          object-fit: cover;
          box-shadow: 0 6px 14px rgba(0,0,0,0.1);
        }

        .about-text {
          flex: 1;
        }

        .about-text h2 {
          color: #00695c;
          margin-bottom: 1rem;
        }

        .about-text h3 {
          color: #00796b;
          margin-top: 2rem;
          margin-bottom: 1rem;
        }

        .about-text p {
          line-height: 1.6;
          color: #333;
          margin-bottom: 1rem;
        }

        /* Gallery styling */
        .gallery {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .gallery-item img {
          width: 100%;
          height: 180px;
          border-radius: 8px;
          object-fit: cover;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
          transition: transform 0.3s ease;
        }

        .gallery-item img:hover {
          transform: scale(1.05);
        }

        /* Contact List */
        .contact-list {
          list-style: none;
          padding: 0;
        }

        .contact-list li {
          margin-bottom: 0.8rem;
          font-size: 1rem;
        }

        .contact-list a {
          margin-left: 0.5rem;
          text-decoration: none;
        }

        .social-icon {
          margin-left: 0.5rem;
          margin-right: 0.5rem;
          vertical-align: middle;
        }

        /* Mobile & Tablet */
        @media (max-width: 768px) {
          .about-container {
            flex-direction: column;
            align-items: center;
          }

          .about-text {
            text-align: center;
          }

          .about-image img {
            height: 350px;
          }

          /* Horizontal scroll for gallery */
          .gallery {
            display: flex;
            overflow-x: auto;
            gap: 1rem;
            padding-bottom: 0.5rem;
          }

          .gallery-item {
            flex: 0 0 auto;
            width: 200px; /* fixed width for scroll items */
          }

          .gallery-item img {
            height: 150px;
          }

          .gallery::-webkit-scrollbar {
            height: 6px;
          }
          .gallery::-webkit-scrollbar-thumb {
            background-color: rgba(0,0,0,0.3);
            border-radius: 3px;
          }
          .gallery::-webkit-scrollbar-track {
            background: transparent;
          }
        }
      `}</style>
    </section>
  );
}
